<template>
  <icon-base
    caption="やること"
    icon="check"
    :action="action"
    route="todo"
  />
</template>

<script>
import IconBase from './Base/index'

export default {
  components: {
    IconBase
  },

  methods: {
    action () {
    }
  }
}
</script>
